// src/pages/PaymentCancel.js
import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

function PaymentCancel() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-red-900 via-slate-900 to-slate-950 text-white p-6">
            <div className="bg-gray-800/80 backdrop-blur-md border border-red-500/50 rounded-xl shadow-2xl p-8 sm:p-12 text-center max-w-lg">
                <XCircle className="w-16 h-16 text-red-400 mx-auto mb-6" />
                <h1 className="text-3xl sm:text-4xl font-extrabold mb-4 text-red-300">Pago Cancelado</h1>
                <p className="text-lg text-gray-300 mb-8">
                    Parece que has cancelado el proceso de pago. No se ha realizado ningún cargo. Puedes volver a intentarlo cuando quieras.
                </p>
                <Link
                    to="/pricing" // Volver a la página de precios
                    className="inline-flex items-center justify-center px-6 py-3 bg-gray-600 rounded-lg text-white font-bold text-lg hover:bg-gray-500 transition-all duration-300 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-gray-500"
                >
                     <ArrowLeft size={20} className="mr-2" />
                    Volver a los Planes
                </Link>
            </div>
        </div>
    );
}

export default PaymentCancel;